import React from "react";
import styles from "./Analytics.module.scss";
import { observer } from "mobx-react-lite";
import { useSearchParams } from "react-router-dom";
import { Tab, Tabs } from "react-bootstrap";
import SellerAnalytics from "./SellersAnalytics";
import WarehouseAnalytics from "./WarehouseAnalytics";

const Analytics: React.FC = observer(() => {
  const [searchParams, setSearchParams] = useSearchParams();

  const newParams = new URLSearchParams(searchParams);

  const tab = searchParams.get("tab");
  const changeTab = (name: string | null) => {
    if (name) {
      newParams.set("tab", name);
      setSearchParams(newParams);
    }
  };

  return (
    <div className={styles.root}>
      <p className={styles.title}>Аналитика</p>
      <div className={styles.wrapper}>
        <Tabs
          defaultActiveKey={tab || "sellersOrdersAnalytics"}
          id="uncontrolled-tab-example"
          className="mb-3"
          onSelect={(e) => changeTab(e)}
        >
          <Tab
            eventKey="sellersOrdersAnalytics"
            title="Аналитика заказов продавцов"
          >
            <SellerAnalytics />
          </Tab>
          <Tab
            eventKey="warehouseOrdersAnalytics"
            title="Аналитика складских заказов"
          >
            <WarehouseAnalytics />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
});
export default Analytics;
